import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../headersService";

export const fetchPlacementGraph = createAsyncThunk('fetchPlacementGraph', async (_, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/student/placement/graph-details`)
        return data
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const placementGraphSlice = createSlice({
    name: 'Placement Graph',
    initialState: {
        loading: false,
        placementGraphDetails : {},
        error: null
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPlacementGraph.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(fetchPlacementGraph.fulfilled, (state, action) => {
            state.loading = false;
            state.placementGraphDetails  = action.payload
        })
        builder.addCase(fetchPlacementGraph.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})

export default placementGraphSlice.reducer